export default "__VITE_ASSET__nUqNpRA7__"